// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetSiteAccountsRequestModel {
    static getAttributeTypeMap() {
        return GetSiteAccountsRequestModel.attributeTypeMap;
    }
}
GetSiteAccountsRequestModel.discriminator = undefined;
GetSiteAccountsRequestModel.additionalProperties = false;
GetSiteAccountsRequestModel.attributeTypeMap = [
    {
        "name": "portalId",
        "baseName": "portalId",
        "type": "string"
    },
];
//# sourceMappingURL=getSiteAccountsRequestModel.js.map